export default __webpack_public_path__ + "static/media/security.a1757a0b.png";